import React from 'react';
import { ComponentTypeNames } from '../../../schema';
import { DatoCmsInformationSectionImage, DatoCmsLink } from '../../../schema/datocms/blocks';
import { ButtonStyles } from '../../../schema/enum/button-styles';
import { MediaContentGrid } from '../../../utilities/media-content-grid';
import Button from '../../button/button';
import HtmlStringComponent from '../../html-string/html-string-component';
import ApiImageComponent from '../api-image/api-image-component';

const InformationSectionImageComponent = ({imageSize, imageAlignment, mainTextHtml, link, apiImage }: DatoCmsInformationSectionImage): React.ReactElement => {
    const mediaContentGrid: MediaContentGrid = new MediaContentGrid(imageSize, imageAlignment);

    let imageContent: JSX.Element | undefined = undefined;

    if (apiImage && apiImage[0]) {
        imageContent = (
            <div className={`flex justify-center lg:col-span-${mediaContentGrid.mediaColumns} lg:col-start-${mediaContentGrid.mediaStartColumn} row-span-2`}>
                <ApiImageComponent className='object-contain object-top' apiImage={apiImage[0]} />
            </div>
        );
    }

    let buttonContent: JSX.Element | undefined = undefined;
    let contentGridRows = mediaContentGrid.gridRows;
    if (link && link.length > 0) {
        const buttonLink: DatoCmsLink = {
            ...link[0],
            __typename: ComponentTypeNames.LINK,
            styleOverride: link[0].styleOverride || ButtonStyles.DEFAULT
        };

        buttonContent = (
            <div className={'flex lg:place-self-auto place-self-center mt-2 lg:block w-max'}>
                <Button {...buttonLink} />
            </div>);
        contentGridRows = 2;
    }

    const descriptionGridClasses: string = `lg:col-end-${mediaContentGrid.contentEndColumn} lg:col-span-${mediaContentGrid.contentColumns} lg:row-start-${mediaContentGrid.contentStartRow} row-span-1`;
    const videoItem = (
        <div className={`grid grid-cols-1 lg:grid-cols-${mediaContentGrid.gridColumns} lg:gap-4 lg:grid-rows-${contentGridRows}`}>
            {imageContent}

            <HtmlStringComponent className={descriptionGridClasses} htmlString={mainTextHtml} />

            {buttonContent}
        </div>
    );

    return videoItem;
};

export default InformationSectionImageComponent;
